import ColorPallet from "./color-pallet.interface";

const pallet: ColorPallet = {
  transparent: "transparent",
  black: "#000",
  white: "#ffffff",
  whiteTransparent: [
    "#FFFFFF10",
    "#FFFFFF20",
    "#FFFFFF30",
    "#FFFFFF40",
    "#FFFFFF50",
    "#FFFFFF60",
    "#FFFFFF70",
    "#FFFFFF80",
    "#FFFFFF90",
    "#FFFFFF99",
  ],
  //Green
  primary: [
    "#CCD9DD",
    "#99B4BC",
    "#678E9A",
    "#346979",
    "#014357",
    "#013646",
    "#012834",
    "#001B23",
    "#000D11",
  ],

  //Red
  secondary: ["#B82E30"],
  secondaryTransparent: [],
  //blue-gray
  neutrals: [
    "#F0F4F8",
    "#D9E2EC",
    "#BCCCDC",
    "#9FB3C8",
    "#829AB1",
    "#627D98",
    "#486581",
    "#334E68",
    "#243B53",
    "#102A43",
  ],

  //Dark
  supportingA: [
    "#000000",
    "#060606",
    "#0C0D0D",
    "#131314",
    "#191A1B",
    "#202122",
    "#262728",
    "#2C2E2F",
    "#333436",
    "#393B3D",
    "#404244",
    "#404244",
    "#535456",
    "#666769",
    "#797A7C",
    "#8C8D8E",
    "#9FA0A1",
    "#B2B3B4",
    "#C5C6C6",
    "#D8D9D9",
    "#EBECEC",
    "#FFFFFF",
  ],

  supportingB: [],
};

export default pallet;
